export default {
  "content": "<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M22.5 3.5a1 1 0 01.895 1.447L21.5 8.737V19.5a1 1 0 01-1 1h-17a1 1 0 01-1-1V8.736L.605 4.947l1.79-.894L4.118 7.5h4.764l1.723-3.447.072-.121A1 1 0 0111.5 3.5h11zm-18 15h4v-9h-4v9zm6 0h9v-9h-9v9zm.618-11h8.764l1-2h-8.764l-1 2z\" fill=\"#7B61FF\"/>",
  "attrs": {
    "width": "24",
    "height": "24",
    "viewBox": "0 0 24 24",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};